import {createApp} from 'vue';
import useAuth from '@/providers/auth';
import App from '@/App.vue'
import router from "@/router";
import filters from "@/filters/filters";
import {rules} from '@/providers/rules';
import 'intl-tel-input/build/css/intlTelInput.css';
import '@/assets/css/global.css';
import HighchartsVue from 'highcharts-vue';
import { VueQueryPlugin, QueryClient, VueQueryPluginOptions } from '@tanstack/vue-query'
// import Highcharts from 'highcharts';
//import exportingInit from 'highcharts/modules/exporting';
//import offlineOption from "highcharts/modules/offline-exporting";
//import Exporting from 'highcharts/modules/exporting';

// import HC_more from "highcharts/highcharts-more";
// import HC_exporting from "highcharts/modules/exporting";

//exportingInit(Highcharts);
//offlineOption(Highcharts);
//Exporting(Highcharts);

// HC_more(Highcharts);
// HC_exporting(Highcharts);

import Maska from "maska";
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'

const {authCheck} = useAuth();

//
const app = createApp(App).use(Quasar, quasarUserOptions);

//Filters
app.config.globalProperties.$filters = filters;
app.config.globalProperties.$rules = rules;

// 1. Crear un QueryClient global
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60, // 1 minuto los datos se consideran "frescos"
            cacheTime: 1000 * 60 * 5, // 5 min antes de borrar cache
            retry: 2, // reintenta 2 veces si falla
        },
        mutations: {
            retry: 1, // reintento de mutaciones si fallan
        }
    }
});

declare global {
    interface Window {
        __TANSTACK_QUERY_CLIENT__:
            import("@tanstack/query-core").QueryClient;
    }
}

window.__TANSTACK_QUERY_CLIENT__ = queryClient;

const vueQueryOptions = {
    queryClient
}

//Auth
authCheck().then(() => {
    app.use(router);
    return router.isReady();
});
//Mascaras
app.use(Maska);

//Graficas
app.use(HighchartsVue)

//Tanstack
app.use(VueQueryPlugin, { queryClient });

//Mount
router.isReady().then(() => {
    app.mount('#app');
});